import React from 'react';
import { motion } from 'framer-motion';

const Process: React.FC = () => {
    const steps = [
        { num: '01', title: 'Choisir un Modèle', desc: "Sélectionnez parmi nos nombreux modèles professionnels." },
        { num: '02', title: 'Remplir vos Infos', desc: "Saisissez votre parcours et vos compétences facilement." },
        { num: '03', title: 'Personnaliser', desc: "Ajustez les couleurs et la mise en forme à votre goût." },
        { num: '04', title: 'Télécharger', desc: "Téléchargez votre CV en PDF prêt pour l'envoi." },
    ];

    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h4 className="text-blue-600 font-semibold uppercase tracking-wider mb-2">Comment ça marche</h4>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Notre Processus Simple</h2>
                </div>

                <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Horizontal Line Connector (Desktop only) */}
                    <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gray-100 -z-10"></div>

                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2 }}
                            className="text-center bg-white p-4"
                        >
                            <div className="w-24 h-24 mx-auto bg-white border-4 border-gray-50 rounded-full flex items-center justify-center shadow-lg mb-6 relative z-10">
                                <span className="text-blue-600 font-bold text-2xl">{step.num}</span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                            <p className="text-gray-500 text-sm">{step.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
